import script from "./GuestNameCollector.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestNameCollector.vue?vue&type=script&setup=true&lang=js"

import "./GuestNameCollector.vue?vue&type=style&index=0&id=10300b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10300b20"]])

export default __exports__